var $eRechnungForm = $(".js-erechnung_form");

$(function(){
    isSubmitErechnung = false;

    if($eRechnungForm.find(".js-submit").val() == 1){
        formMsgBlockShowHide($eRechnungForm.find(".js-form_successblock"), 5000);
    }

    $eRechnungForm.find(".js-from_submit").on("click", function(event){
        event.preventDefault();

       if(isSubmitErechnung && typeof isSubmitErechnung != "undefined") return false;
        $currentButton = $(this);
        $currentButton.addClass("button_disabled")
        isSubmitErechnung = true;

        var validSubmit = true;
        var errorCount = 0;

        $.each($eRechnungForm.find(".js-form_input"), function(key, value){
            validInput = checkInput($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        $eRechnungForm.find(".js-form_checkbox").each(function(){
            validInput = checkCheckbox($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        if(validSubmit){
            showLoader();

            requestData = "";
            if(typeof $eRechnungForm[0] != "undefined"){
                $eRechnungForm.each(function(index){
                    requestData += "&" + $(this).serialize();
                });
            }

            $.ajax({
                url:$(this).data("ajax"),
                data:requestData,
                type:"POST",
            }).done(function(errors){
                $currentButton.removeClass("button_disabled")
                isSubmitErechnung = false;

                if(errors == ""){
                    $eRechnungForm.trigger('submit');
                }else{
                    var errorCount = 0;
                    errors = JSON.parse(errors);

                    $.each(errors, function(key, value){
                        var $field = $("[name=" + value + "]");
                        var $label = $field.siblings(".js-form_label");

                        // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
                        var label_text = $field.attr("label_text");
                        if(typeof label_text == 'undefined' || label_text.length == 0) label_text = $field.attr("placeholder");

                        $label.addClass("form_label_text-error");
                        $label.text(label_text + " - " + $field.attr("title"));
                        errorCount++;
                    });

                    formMsgBlockShow($eRechnungForm.find(".js-form_errorblock"));
                }
                hideLoader();
            });
        }else{
            $currentButton.removeClass("button_disabled")
            isSubmitErechnung = false;
            formMsgBlockShow($eRechnungForm.find(".js-form_errorblock"));
            hideLoader();
        }
    });
});